import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/core/core.module';
import { Router, ActivatedRoute, IsActiveMatchOptions, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.less']
})
export class SecurityComponent implements OnInit {

  constructor(
    public localStorageService: LocalStorageService,
    public router: Router,
  ) { }

  ngOnInit(): void {
  }

  goBack(){
    let previousUrl = String(this.localStorageService.get('prevUrlFooter') || '/');
    this.router.navigateByUrl('', { skipLocationChange: false});
  }
}
